import sequencerReducer from 'reducers/sequencer.js';
import pluginsReducer from './pluginsReducer.js';
import documentationReducer from './documentationReducer.js';
import spatialReducer from './spatialReducer.js';
import nftReducer from 'reducers/nftReducer.js';
import zobjectReducer from 'reducers/zobjectReducer.js';
import higherOrderReducer from 'reducers/higherOrderReducer.js';
import installationReducer from 'reducers/installationReducer.js';
import cirklonReducer from 'reducers/cirklonReducer.js';
import tracksReducer from 'reducers/tracksReducer.js';
import freezeReducer from 'reducers/freezeReducer.js';
import samplesReducer from 'reducers/samplesReducer.js';
import automationReducer from 'reducers/automationReducer.js';
import cursorReducer from 'reducers/cursorReducer.js';
import instrumentsReducer from 'reducers/instrumentsReducer.js';
import guildsReducer from 'reducers/guildsReducer.js';
import paletteReducer from 'reducers/paletteReducer.js';
import mixReducer from 'reducers/mixReducer.js';
import presetsReducer from 'reducers/presetsReducer.js';
import keyboardReducer from 'reducers/keyboardReducer.js';
import effectsReducer from 'reducers/effectsReducer.js';
import selectorReducer from 'reducers/selectorReducer.js';
import auditionReducer from 'reducers/auditionReducer.js';
import userReducer from 'reducers/userReducer.js';
import toolbarReducer from 'reducers/toolbarReducer.js';
import stepsReducer from 'reducers/stepsReducer.js';
import discoverReducer from 'reducers/discoverReducer.js';
import midiReducer from 'reducers/midiReducer.js';
import clockReducer from 'reducers/clockReducer.js';
import modalsReducer from 'reducers/modalsReducer.js';
import arrangementReducer from 'reducers/arrangementReducer.js';
import waveformReducer from 'reducers/waveformReducer.js';
import transactionsReducer from 'reducers/transactionsReducer.js';
import commandsReducer from 'reducers/commandsReducer.js';
import exploreReducer from 'reducers/exploreReducer.js';
import packsReducer from 'reducers/packsReducer.js';
import padsReducer from 'reducers/padsReducer.js';
import groupsReducer from 'reducers/groupsReducer.js';
import planeReducer from 'reducers/planeReducer.js';
import windowsReducer from 'reducers/windowsReducer.js';
import {combineReducers} from 'redux';

const rootReducer = combineReducers(
    {
        sequencer: sequencerReducer,
        tracks: tracksReducer,
        groups: groupsReducer,
        packs: packsReducer,
        cursor: cursorReducer,
        samples: samplesReducer,
        guilds: guildsReducer,
        palette: paletteReducer,
        presets: presetsReducer,
        mix: mixReducer,
        keyboard: keyboardReducer,
        effects: effectsReducer,
        selector: selectorReducer,
        spatial: spatialReducer,
        audition: auditionReducer,
        user: userReducer,
        toolbar: toolbarReducer,
        steps: stepsReducer,
        documentation: documentationReducer,
        discover: discoverReducer,
        midi: midiReducer,
        clock: clockReducer,
        modals: modalsReducer,
        arrangement: arrangementReducer,
        waveform: waveformReducer,
        transactions: transactionsReducer,
        commands: commandsReducer,
        freeze: freezeReducer,
        explore: exploreReducer,
        instruments: instrumentsReducer,
        automation: automationReducer,
        installation: installationReducer,
        cirklon: cirklonReducer,
        pads: padsReducer,
        plane: planeReducer,
        windows: windowsReducer,
        higherOrder: higherOrderReducer,
        zobject: zobjectReducer,
        nft: nftReducer,
        plugins: pluginsReducer
    });

export default rootReducer;
